export default __webpack_public_path__ + "static/media/Lifescience.c32cfb62.svg";